import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { EnviarEmailEnum } from '../../shared/dominios/enum/enviar-emails.enum';

@Component({
  selector: 'app-enviar-email',
  templateUrl: './enviar-email.component.html',
  styleUrls: ['./enviar-email.component.css']
})
export class EnviarEmailComponent implements OnInit {

  param = '/cardMenus/cardMenuAdministrativo';

  valoresEnviarEmails: SelectItem[] = EnviarEmailEnum.values;

  tipoEnvio: number;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/administrativo/enviar-email/enviar-email.component.ts